<!-- =========================================================================================
    File Name: TodoEdit.vue
    Description: Edit todo component
    ----------------------------------------------------------------------------------------
    Item Name: Legal Board Services
      Author: Enkompass
    Author URL: https://www.enkompass.net
========================================================================================== -->


<template>
    <vs-prompt
        :title="addType"
        :buttons-hidden="true"
        :auto-width="true"
        @close="init"
        :is-valid="validateForm"
        :active.sync="activePrompt"
        v-bind:class="dialogClass"
    >
        <div>
            <form>
                <div class="vx-row" v-if="formData && randomValue">
                  <div
                    class="vx-col w-full"
                    v-bind:class="{'md:w-1/3': menuType === 'accounts', 'md:w-1/2': menuType === 'cases'}"
                    v-for="(item, index) in formData"
                  >
                      <vs-select
                        autocomplete
                        v-if="item.fieldType === 'head_counsel'"
                        class="w-full mb-4 mt-5"
                        :label="item.fieldLabel"
                        :placeholder="item.placeholder"
                        :name="item.fieldName"
                        v-model="item.value"
                      >
                        <vs-select-item :key="index" :value="item.uuid" :text="item.uuid"
                                        v-for="(item,index) in userList" />
                      </vs-select>
                      <div v-if="item.fieldName !== 'lawFirmAddressState'">
                        <vs-textarea
                          :label="item.fieldLabel"
                          :name="item.fieldName"
                          v-if="item.fieldType === 'textarea'"
                          :placeholder="item.fieldLabel"
                          class="w-full mb-4 mt-5"
                          height="120px"
                          v-model="item.value"
                        />
                        <vs-input
                          v-if="!item.mask && item.fieldType !== 'textarea' && item.fieldType !== 'head_counsel'"
                          class="w-full mb-4 mt-5"
                          v-model="item.value"
                          :danger="formData[index].errorHint != null"
                          :danger-text="formData[index].errorHint"
                          :required="item.required"
                          :name="item.fieldName"
                          :type="item.fieldType"
                          :label="item.fieldLabel"
                          :placeholder="item.fieldLabel"
                        />
                        <vs-input
                          v-if="item.mask"
                          class="w-full mb-4 mt-5"
                          v-model="item.value"
                          :required="item.required"
                          :name="item.fieldName"
                          :type="item.fieldType"
                          :label="item.fieldLabel"
                          :danger="formData[index].errorHint != null"
                          :danger-text="formData[index].errorHint"
                          v-mask="item.mask"
                          :placeholder="item.placeholder"
                        />
                      </div>
                      <div v-else>
                        <vs-select
                          autocomplete
                          @input-change="autoCompleteState"
                          class="w-full mb-4 mt-5"
                          :label="item.fieldLabel"
                          :placeholder="item.placeholder"
                          :name="item.fieldName"
                          v-model="item.value"
                        >
                          <vs-select-item :key="index" :value="item.name" :text="item.name"
                                          v-for="(item,index) in searchedStateList" />
                        </vs-select>
                      </div>
                    </div>
                </div>
            </form>
            <footer>
              <button :disabled="processing === 1" id="add-frm-btn" class="vs-con-loading__container vs-component
                vs-button vs-dialog-accept-button vs-button-primary vs-button-border" @click="execute" name="button">
                Submit
              </button>
            </footer>
        </div>
    </vs-prompt>
</template>

<script>
import axios from '@/axios.js'

export default {
  props: {
    displayAddPrompt: {
      type: Boolean,
      required: true
    },
    taskId: {
      required: true
    }
  },
  data () {
    return {
      randomValue: Math.random(),
      dialogClass: {},
      fieldData: {
        accounts : {
          name : 'Law Firm Name',
          alias: "Law Firm Alias",
          lawFirmPhone: "Law Firm Phone",
          primaryContactName: "Primary Contact Name",
          primaryContactPhone: "Primary Contact Phone",
          primaryContactEmail: "Primary Contact Email",
          lawFirmAddress1: "Address Line #1",
          lawFirmAddress2: "Address Line #2",
          adminNotes: "Notes",
          lawFirmAddressCity: "City",
          lawFirmAddressState: "State",
          lawFirmAddressZipcode: "Zipcode",
          lawFirmWebsite: "Law Firm Website",
          encryptionKey: 'Encryption Key',
        },
        cases : {
          name : 'Name',
          headCounsel: "Lead Counsel",
          primaryContactPhone: "Primary Contact Phone",
          primaryContactEmail: "Primary Contact Email",
          primaryContactTitle: "Primary Contact Title",
        },
        users : { name : 'Full Name', uuid: 'Email Address', password : 'Password' }
      },
      taskLocal: this.taskId,
      formData : [],
      userList : [],
      processing : 0,
      allStateList: [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"District Of Columbia","abbreviation":"DC"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}],
      searchedStateList: [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"District Of Columbia","abbreviation":"DC"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}]
    }
  },
  created() {
    if (this.taskId && this.taskId.addType) {
      this.dialogClass['vs-dialog-' + this.taskId.addType] = true;
    }
    if (this.menuType === 'cases' && this.taskId && this.taskId.accountId) {
      let vm = this
      axios.get("/accounts/" + this.taskId.accountId + "/users")
        .then(response => {
          if (response && response.data && response.data.items) {
            vm.userList = response.data.items;
          }
        }).catch(error => {
        console.log(error);
      })
    }
    for(let item in this.fieldData[this.menuType]){
      let typ = 'text'
      if(item === 'password') typ = 'password'
      if(item === 'primaryContactEmail') typ = 'email'
      if(item === 'lawFirmAddress1' || item === 'lawFirmAddress2' || item === 'adminNotes') typ = 'textarea'
      let formItem = {
        fieldName: item,
        fieldLabel : this.fieldData[this.menuType][item],
        placeholder : this.fieldData[this.menuType][item],
        value: '',
        fieldType : typ,
        required: false
      }
      if (item === 'lawFirmWebsite') {
        formItem.validator = this.validWebsite;
      }
      if (item === 'headCounsel') {
        formItem.fieldType = "head_counsel";
      }
      if(item === 'primaryContactEmail') {
        formItem.validator = this.validEmail;
      }
      if(item === 'lawFirmAddressZipcode') {
        formItem.validator = this.validZipcode;
      }
      if (item === 'name') formItem.required = true;
      if (item === 'alias') formItem.validator = this.validAlias;
      if (item === 'lawFirmPhone' || item === 'primaryContactPhone') {
        formItem.mask = "+1 (###) ###-####";
        formItem.placeholder = "+1 (999) 999-9999";
        formItem.validator = this.validPhone;
      }
      this.formData.push(formItem)
    }
  },
  computed: {
    activePrompt: {
      get () {
        return this.displayAddPrompt
      },
      set (value) {
        this.$emit('hideDisplayPrompt', {shouldRefresh: false, menuType: this.menuType})
      }
    },
    validateForm () {
    },
    getInputType(field) {
      if(field === 'password'){
        return 'password'
      }

      return 'text';
    },
    menuType () {
      if(this.taskLocal.addType === 'case'){
        return 'cases'
      }

      if(this.taskLocal.addType === 'user'){
        return 'users'
      }

      return this.$store.state.todo.menuType
    },
    addType () {
      if(this.menuType === 'accounts'){
         return 'Add Law Firm'
      }

      if(this.menuType === 'users'){
         return 'Add User'
      }

      return 'Add Case' // + this.menuType
    },
    fixType (){
      if(this.menuType === 'accounts'){
         return 'firm'
      }

      if(this.menuType === 'users'){
         return 'user'
      }

      if(this.menuType === 'cases'){
         return 'case'
      }

      return this.menuType
    }
  },
  methods: {
    validAlias(alias) {
      return alias && !alias.startsWith("_") && alias.length <= 16;
    },
    validEmail(email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
    },
    validPhone(phone) {
      return /\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}/.test(phone)
    },
    validWebsite(website) {
      return /https?:\/\/.*/.test(website)
    },
    validZipcode(zip) {
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)
    },
    autoCompleteState(event) {
      try {
        let searchTerm = event.target.value;
        return this.allStateList
          .filter(item => item.name.search(new RegExp(searchTerm, 'i')) > -1 ||
            item.abbreviation.search(new RegExp(searchTerm, 'i')) > -1)
      } catch(e){}
    },
    execute (){
      let newData = {}, isValid = true;
      for(let itm =0; itm < this.formData.length; itm++){
        this.formData[itm].errorHint = null;
        newData[this.formData[itm].fieldName] = this.formData[itm].value
        if (this.formData[itm].required && !this.formData[itm].value) {
          isValid = false;
          this.formData[itm].errorHint = "This field is required";
        }
        if (this.formData[itm].validator && this.formData[itm].value) {
          let validity = this.formData[itm].validator(this.formData[itm].value);
          if (!validity) {
            isValid = false;
            this.formData[itm].errorHint = "Invalid value";
          }
        }
      }
      this.randomValue = Math.random()
      if (isValid) {
        this.$vs.loading({
          container: "#add-frm-btn",
          scale: 0.45
        })

        this.processing = 1;
        newData.firmId = this.taskLocal.uuid

        if(this.taskLocal.addType === 'user'){
          newData.type = 'new'
          newData.addType = 'user'
        }

        if(this.taskLocal.addType === 'case'){
          newData.type = 'new'
          newData.addType = 'case'
        }

        this.$store.dispatch('todo/addData', newData)
          .then(response => {
            this.processing = 0
            this.$vs.loading.close('#add-frm-btn > .con-vs-loading')
            this.$emit('hideDisplayPrompt', {shouldRefresh: true, menuType: this.menuType})
          })
          .catch(err => {
            let message = err;
            if (err && err.message) message = err.message;
            else if (err && err.response && err.response.data && err.response.data.message) message = err.response.data.message;
            else if (err && err.data && err.data.message) message = err.data.message;
            this.processing = 0
            this.$vs.loading.close('#add-frm-btn > .con-vs-loading')
            this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: message
            })
          });
      }
    },
    removeTodo () {
    },
    init () {
    },
    submitTodo () {
    }
  }
}
</script>

<style>
  .vs-dialog-account .vs-dialog, .vs-dialog-case .vs-dialog {
    max-width: 80vw !important;
    width: 80vw !important;
  }
  .vs-dialog-account form, .vs-dialog-case form {
    max-height: 50vh;
    padding: 0 16px;
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
